import { useSelector } from "react-redux";
import { openFullWebView, checkIsMobileApp } from "bridge/common/CommonBridge";
import { getStarShopUrl } from "utils/url";
import { isBelowVersion } from "utils/version";
import AlertConfirmPopupNew from "components/common/AlertConfirmPopupNew";

// 스타샵 진입이 가능한 앱 최소 버전
const STAR_SHOP_MIN_VERSION = "1.0.30";

// 외부 스타샵 웹앱으로 이동시키는 훅 (로그인 정보는 Redux에서 조회)
export const useGoStarShop = () => {
    const contractNumber = useSelector((state) => state.loginReducer.contractNumber);
    const customerNumber = useSelector((state) => state.loginReducer.customerNumber);

    return () => {
        if (checkIsMobileApp()) {
            const nativeInfo = window.__NATIVE__;

            // 최소 버전 미만이면 업데이트 안내 팝업 노출 후 이동 차단
            if (!nativeInfo || isBelowVersion(nativeInfo.version, STAR_SHOP_MIN_VERSION)) {
                AlertConfirmPopupNew({
                    type: "ALERT",
                    msg: "<h1>새로운 스타샵을 만나볼까요!</h1><p>App Store에서 '스마트올 중학' 최신 버전으로\n업데이트하고 새로운 스타샵을 만나세요.</p>",
                });
                return;
            }
        }

        const url = getStarShopUrl({ contractNumber, customerNumber });
        openFullWebView(url);
    };
};
